import React, { useContext, useEffect, useState } from 'react'
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import agent from '../../../../services/api';
import { MetaContext, MetaContextPayload } from '../../../../context/metaContext';
import { addChatbotIntegrationPayload, chatbotIntegrationAssignmentData, globalIntegration, removeChatbotIntegrationDetailsInterface } from '../../../../models/axiosModel';
import GlobalPopUp from '../../../utility/globalPopUp';
import GlobalDeletePopup from '../../../utility/globalDeletePopup/globalDeletePopup';
import Confirmation from '../../../popupFiles/confirmation';
import { ChatbotContext, ChatbotContextPayload } from '../../../../context/chatbotContext';
import FacebookInformationCard from '../../../utility/facebookInformationCard';
import { IntegrationContext, IntegrationContextPayload } from '../../../../context/integrationContext';
import { GenericDataContext, GenericDataContextPayload } from '../../../../context/genericDataContext';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, homeBreadcrumb, integrationDetailsBreadcrumb } from '../../../../utils/breadcrumb';
import { useGenericStore } from '../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';


const ChatbotInstagramIntegrationDetails = () => {
    const navigate = useNavigate()
    const [currentActiveFacebookIntegration, setCurrentActiveFacebookIntegration] = useState<globalIntegration[] | null>(null)
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload
    const [searchParams] = useSearchParams()
    const chatbot_id = searchParams.get('chatbot_id');
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { globalIntegrationTypeList } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { GetChatbotIntegrationData, getChatbotIntegrationData, setGetChatbotIntegrationData } = useContext(MetaContext) as MetaContextPayload;
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [flagAddIntegration, setFlagAddIntegration] = useState<boolean>(false)
    const [phoneNumberIntegrate, setPhoneNumberIntegrate] = useState<string>("")

    const [addChatbotIntegrationDetails, setAddChatbotIntegrationDetails] = useState<addChatbotIntegrationPayload>({
        chatbot_id: "",
        integrated_channel_id: ""
    })
    const [removeChatbotIntegrationDetails, setRemoveChatbotIntegrationDetails] = useState<removeChatbotIntegrationDetailsInterface>({
        chatbot_id: "",
        integrated_channel_id: ""
    })
    let pathname = window.location.pathname.toLowerCase();

    useEffect(() => {
        if (getChatbotIntegrationData !== null && getChatbotIntegrationData.length > 0 && getChatbotIntegrationData.filter((data: globalIntegration) => data.meta_integration_type_assignment_data.channel_name.toLowerCase() == "facebook")) {
            let assignment_id = Number(searchParams.get('assignment_id'))
            if (assignment_id) {
                let facebookIntegrationData = getChatbotIntegrationData.filter((integrationData: globalIntegration) => integrationData.meta_integration_type_assignment_data.channel_name.toLowerCase() === "facebook")
                let currentActiveWhatsappData = facebookIntegrationData.filter((data: globalIntegration) => data?.meta_integration_facebook_data?.meta_integration_facebook_id == assignment_id)
                if (currentActiveWhatsappData && currentActiveWhatsappData.length > 0) {
                    setCurrentActiveFacebookIntegration(currentActiveWhatsappData)
                } else {
                    let chatbot_id = searchParams.get('chatbot_id')
                    navigate(`/chatbot/viewchatbot/channels/facebook?chatbot_id=${chatbot_id}`)
                }
            } else {
                let chatbot_id = searchParams.get('chatbot_id')
                navigate(`/chatbot/viewchatbot/channels/facebook?chatbot_id=${chatbot_id}`)
            }
        } else {
            let chatbot_id = searchParams.get('chatbot_id')
            navigate(`/chatbot/viewchatbot/channels/facebook?chatbot_id=${chatbot_id}`)
        }
    }, [getChatbotIntegrationData, window.location.href])

    useEffect(() => {
        const updatedBreadcrumbs = [
            {...homeBreadcrumb}, 
            AIChatbotBreadcrumb, 
            {...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", path: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`}, 
            { name: "Instagram Integration", path: `/chatbot/viewchatbot/channels/instagram?chatbot_id=${chatbot_id}`, isActive: false}, 
            { ...integrationDetailsBreadcrumb, isActive: true }
        ]; 
        setBreadCrumbs(updatedBreadcrumbs);
    }, [chatBotDetails])

    const deleteChatbotIntegration = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        let channel_id = globalIntegrationTypeList?.find((channel) => channel?.channel_name?.toLowerCase() == 'instagram')?.channel_id.toString() || ''
        const response = await agent.removeChatbotIntegration.delete(
            channel_id,
            removeChatbotIntegrationDetails.chatbot_id,
            removeChatbotIntegrationDetails.integrated_channel_id
        )
            ;
        if (response.status) {
            showSuccess("Integration Removed Successfully")
            const res = await GetChatbotIntegrationData(removeChatbotIntegrationDetails.chatbot_id, "")
            if(!(res.status)){
                handleError(res);    
            }
        } else {
            handleError(response);
        }
        setShowDeleteConfirmation(false)
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }
    const handleRemoveChatbotIntegration = () => {
        if (getChatbotIntegrationData && currentActiveFacebookIntegration) {
            let chatbot_id = searchParams.get('chatbot_id')
            if (chatbot_id) {
                setRemoveChatbotIntegrationDetails(
                    {
                        chatbot_id: chatbot_id, 
                        integrated_channel_id: currentActiveFacebookIntegration[0].meta_integration_facebook_data?.integrated_channel_id || "",
                        // meta_integration_type_id: currentActiveFacebookIntegration[0].meta_integration_type_assignment_data.meta_integration_type_id,
                        // page_id: currentActiveFacebookIntegration[0].meta_integration_facebook_data.page_id,
                        // meta_integration_id: currentActiveFacebookIntegration[0].meta_integration_id
                    }
                )
            }
            setShowDeleteConfirmation(true)
            setPhoneNumberIntegrate(currentActiveFacebookIntegration[0].meta_integration_facebook_data?.page_name || "")
        }
    }

    function addChatbotIntegration() {

        let chatbot_id = searchParams.get('chatbot_id')
        if (chatbot_id && currentActiveFacebookIntegration) {
            setAddChatbotIntegrationDetails((prevState) => ({
                ...prevState,
                // page_id: currentActiveFacebookIntegration[0].meta_integration_facebook_data.page_id,
                // meta_integration_type_id: currentActiveFacebookIntegration[0].meta_integration_type_id,
                chatbot_id: chatbot_id,
                integrated_channel_id: currentActiveFacebookIntegration[0].meta_integration_facebook_data?.integrated_channel_id || ""
                // meta_integration_id: currentActiveFacebookIntegration[0].meta_integration_id
            }))
        }
        setFlagAddIntegration(true)
        setPhoneNumberIntegrate(currentActiveFacebookIntegration?.[0]?.meta_integration_facebook_data?.page_name || "")
    }
    async function AddChatbotIntegration() {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const response = await agent.addChatbotIntegration.post(addChatbotIntegrationDetails)
        if (response.status) {
            showSuccess("Integration Successfull!")
            setGetChatbotIntegrationData(response.data)
        } else {
            handleError(response);
        }
        setFlagAddIntegration(false)
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }
    return (
        <>
            {currentActiveFacebookIntegration &&
                <FacebookInformationCard
                    integrationType="facebook"
                    key={currentActiveFacebookIntegration ? currentActiveFacebookIntegration[0]?.meta_integration_facebook_data?.meta_integration_facebook_id : 1}
                    flagDelete={false}
                    title={"Meta"}
                    // flagShowMetaIcon={true}
                    currentlySelected={currentActiveFacebookIntegration[0].meta_integration_facebook_data?.chatbot_integration_assignment_data.some((chatbot: chatbotIntegrationAssignmentData) => chatbot.chatbot_id.toString() == searchParams.get('chatbot_id')) || false}
                    removeChatbotIntegration={() => { handleRemoveChatbotIntegration() }}
                    addChatbotIntegration={() => { addChatbotIntegration() }}
                    details={{
                        page_id: currentActiveFacebookIntegration[0]?.meta_integration_facebook_data?.page_id,
                        integrated_channel_id: currentActiveFacebookIntegration[0]?.meta_integration_facebook_data?.integrated_channel_id || "",
                        page_name: currentActiveFacebookIntegration[0]?.meta_integration_facebook_data?.page_name,
                        page_category: currentActiveFacebookIntegration[0]?.meta_integration_facebook_data?.page_category,
                        linked_chatbots: currentActiveFacebookIntegration[0]?.meta_integration_facebook_data?.chatbot_integration_assignment_data
                    }}
                    deleteChatbotIntegration={() => {
                        setShowDeleteConfirmation(true)
                    }
                    }
                    flagIntegration={true}
                />
            }
            {flagAddIntegration &&
                <GlobalPopUp
                    open={flagAddIntegration}
                    handleClose={() => { setFlagAddIntegration(false) }}
                    flagShowCloseIcon
                >
                    <Confirmation
                        integration='whatsapp'
                        cancel={() => { setFlagAddIntegration(false) }}
                        continue={AddChatbotIntegration}
                        confirmationMessage={`Are you sure you want to integrate ${phoneNumberIntegrate} to ${chatBotDetails?.chatbot_name}`}
                    />
                </GlobalPopUp>
            }
            {
                showDeleteConfirmation &&
                <GlobalDeletePopup
                    open={showDeleteConfirmation}
                    title={"Undeploy Chatbot Confirmation"}
                    deleteDescription={`Are you sure you want to undeploy ${chatBotDetails?.chatbot_name} from ${phoneNumberIntegrate}`}
                    onClose={() => { setShowDeleteConfirmation(false) }}
                    onDelete={deleteChatbotIntegration}
                    primaryButtonText={"Undeploy"}
                />
            }
        </>
    )
}

export default ChatbotInstagramIntegrationDetails;